export interface CallTagModel {
    id: number;
    environment_id: string;
    key: string;
    value: string;
}
